import React, { useState } from 'react';
import { PortfolioStuffingAsset } from './asset/PortfolioStuffingAsset';
import { PortfolioStuffingDebt } from './debt/PortfolioStuffingDebt';
import { AssetBundleType } from 'components/features/home/Home';
import { GetUserAssetResult, GetUserBrokerResultItem } from 'config/api';

type PortfolioStuffingProps = {
  asset: GetUserAssetResult;
  brokersInfo: GetUserBrokerResultItem[];
  UserBrokerUpdateTime: React.ReactElement;
  assetBundleType: AssetBundleType;
  getIsOutOfDate: (arg: { account: string }) => boolean | null;
  toPreview: (element: React.ReactElement) => void;
  backHome: () => void;
};

export type DispType = '資産' | '負債';

export const PortfolioStuffing = ({
  asset,
  brokersInfo,
  UserBrokerUpdateTime,
  assetBundleType,
  getIsOutOfDate,
  toPreview,
  backHome,
}: PortfolioStuffingProps): React.ReactElement => {
  const [dispType, setDispType] = useState<DispType>('資産');

  return (
    <>
      <div
        className="absolute top-10 w-full ml-auto mr-auto z-10"
        style={{ top: '2rem' }}>
        <div className="flex flex-row justify-center">
          <div
            className={`border border-white py-1 px-3 text-xs rounded-l ${
              dispType === '資産' ? 'bg-white' : 'text-white'
            } cursor-pointer`}
            onClick={() => setDispType('資産')}>
            資産
          </div>
          <div
            className={`border border-white py-1 px-3 text-xs rounded-r ${
              dispType === '負債' ? 'bg-white' : 'text-white'
            } cursor-pointer`}
            onClick={() => setDispType('負債')}>
            負債
          </div>
        </div>
      </div>
      {dispType === '資産' ? (
        <PortfolioStuffingAsset
          {...{
            asset,
            brokersInfo,
            UserBrokerUpdateTime,
            assetBundleType,
            getIsOutOfDate,
            backHome,
            toPreview,
          }}
        />
      ) : (
        <PortfolioStuffingDebt
          {...{
            UserBrokerUpdateTime,
            groupKey: assetBundleType.key,
          }}
        />
      )}
    </>
  );
};
